/* eslint-disable no-mixed-operators */
import React, { useState } from 'react'
import Modal from '@material-ui/core/Modal'
import ConstructionsForm from './ConstructionsForm'
import useConstructionStore from '../../stores/ConstructionStore'
import { useHistory } from 'react-router-dom'
import CustomTable from '../customTable/CustomTable'
import ListHeader from '../common/ListHeader'

export default function ConstructionsList({ building, redirectTo }) {
  const [modalOpen, setModalOpen] = useState(false)
  const state = useConstructionStore((state) => state)
  const getConstructions = (params) => {
    state.fetchConstructions(params)
  }
  const history = useHistory()
  const columns = [
    { id: 'name', label: 'Referencia', minWidth: 170 },
    { id: 'description', label: 'Observaciones', minWidth: 170 },
    {
      id: 'date',
      label: 'Fecha inicio',
      minWidth: 170,
      format: (value) => new Date(value.date).toLocaleString('es'),
    },

    !building
      ? {
          id: 'building',
          label: 'Cliente/Unidades',
          minWidth: 170,
          format: (value) =>
            value.apartments?.map((apartment) => apartment.name).join(', '),
        }
      : {
          id: 'building',
          label: 'Unidades',
          minWidth: 170,
          format: (value) =>
            value.apartments?.map((apartment) => apartment.name).join(', '),
        },
    {
      id: '',
      label: '',
      minWidth: 5,
    },
  ]

  const options = (construction) => [
    {
      key: 'edit',
      label: 'Editar',
      onClick: () => {
        history.push('/nueva-obra', { construction, previousRoute: redirectTo })
      },
    },
    {
      key: 'delete',
      label: 'Eliminar',
      onClick: () => {
        state.deleteConstruction(construction.id)
      },
    },
  ]

  const constructions = state?.constructions || []

  return (
    <>
      <ListHeader
        bigTitle="Obras"
        createText="Nueva obra"
        createRedirect={() => history.push('nueva-obra')}
      />
      <CustomTable
        loading={state.isLoading}
        columns={columns}
        data={constructions || []}
        getData={(params) => getConstructions({ ...params })}
        buildingFilter={!building}
        building={building}
        apartmentFilter={false}
        searchTitle={'Referencia o unidad'}
        searchPlaceholder={'Ingrese una referencia o unidad'}
        serverPagination={true}
        serverCount={state?.count}
        options={options}
        handleRowClick={(item) => {
          history.push(`/obras/${item.id}`)
        }}
      ></CustomTable>
      <Modal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        aria-labelledby="simple-modal-title"
      >
        <ConstructionsForm
          closeModal={() => setModalOpen(false)}
          handleCancel={() => setModalOpen(false)}
          building={{ ...building }}
        />
      </Modal>
    </>
  )
}
